import { createClient } from '@/lib/contentful/initContentful';
import { IShopping } from '@/@types/generated/contentful';

const client = createClient();

export async function fetchShoppingsEntries() {
  let shoppingList: IShopping[] = [];
  await client
    .getEntries({
      content_type: 'shopping',
      order: 'fields.id'
    })
    .then((doc) => {
      shoppingList = (doc.items as IShopping[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return shoppingList;
}

export async function fetchFeatureShoppingsEntries(feature: string) {
  let shoppingList: IShopping[] = [];
  await client
    .getEntries({
      content_type: 'shopping',
      'fields.feature': feature,
      order: 'fields.id'
    })
    .then((doc) => {
      shoppingList = (doc.items as IShopping[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return shoppingList;
}

export async function fetchSameCategoryShoppingsEntries({
  shoppingCat,
  shoppingId
}: {
  shoppingCat: string;
  shoppingId: string;
}) {
  let shoppingList: IShopping[] = [];
  await client
    .getEntries({
      content_type: 'shopping',
      'fields.cat': shoppingCat,
      order: 'fields.id'
    })
    .then((doc) => {
      shoppingList = (doc.items as IShopping[]).filter((el) => el.fields.id !== shoppingId);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return shoppingList;
}

export async function fetchFavoritedShoppingsEntries(favoritedList: string[]) {
  const result: IShopping[] = await Promise.all(
    favoritedList.map((item) => {
      return client
        .getEntries({
          content_type: 'shopping',
          'fields.id': item,
          order: 'fields.id'
        })
        .then((doc) => {
          return doc.items[0] as IShopping;
        })
        .catch((error) => {
          throw new Error(error);
        });
    })
  );
  const shoppingList = result.filter((item) => item);
  return shoppingList;
}

export async function fetchShoppingEntry(slug: string) {
  let shopping: IShopping | null = null;
  await client
    .getEntries({
      content_type: 'shopping',
      'fields.slug': slug
    })
    .then((doc) => {
      shopping = doc.items[0] as IShopping;
    })
    .catch((error) => {
      throw new Error(error);
    });
  return shopping;
}
